import React from "react";
import { graphql, Link } from "gatsby";
import Layout from "../components/layout";
import ImageGallery from "../components/image-gallery";

export default function Gallery ({pageContext, data}) {

    const galleryName = pageContext.galleryDirectory?.split('/')[1];
    const images = data.allFile.nodes;

    return (
        <Layout>
            <Link to={'/galleries/'}>Galleries </Link><span>\ {galleryName}</span>
            <h1>{galleryName}</h1>
            <ImageGallery images={images}/>
        </Layout>
    )
}

export const pageQuery = graphql`
    query($galleryDirectory: String) {
        allFile(filter: {relativeDirectory: {eq: $galleryDirectory}}) {
            nodes {
                childImageSharp {
                    fluid(maxWidth: 1024) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    }
`;